import { TranslationChunksConfig } from '@spartacus/core';
import userEn from './en/user.json';
import userEs from './es/user.json';

export const customUserTranslationsEn = {
  user: userEn
};

export const customUserTranslationsEs = {
  user: userEs
};

export const customUserTranslationsChunksConfig: TranslationChunksConfig = {
  user: ['anonymousConsents', 'checkoutLogin', 'authMessages']
};
